import axios from 'axios';

export default class LocationService {
  static async getLocation(shopID: string): Promise<Shop | null> {
    const accountID = window.merchantos.account.id;

    try {
      const response = await axios.get(`/API/V3/Account/${accountID}/Shop/${shopID}.json`, {
        params: {
          load_relations: '["Contact"]',
        },
      });
      return response?.data?.Shop;
    } catch (error) {
      return null;
    }
  }

  static async getShopsWithRegisters(): Promise<Shop[]> {
    const accountID = window.merchantos.account.id;

    try {
      const response = await axios.get(`/API/Account/${accountID}/Shop.json`, {
        params: {
          load_relations: '["Registers"]',
          archived: 1,
        },
      });
      const raw = response?.data?.Shop;
      if (!raw) return [];
      return Array.isArray(raw) ? raw : [raw];
    } catch {
      return [];
    }
  }
}
